import { render, staticRenderFns } from "./dataRef.vue?vue&type=template&id=a685a940&scoped=true"
import script from "./dataRef.vue?vue&type=script&lang=js"
export * from "./dataRef.vue?vue&type=script&lang=js"
import style0 from "./dataRef.vue?vue&type=style&index=0&id=a685a940&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a685a940",
  null
  
)

export default component.exports